import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Separator from '../components/Separator';
import FeaturedSolutions, { FeaturedItem } from '../components/FeaturedSolutions';
import tabletInfoGenesis from '../assets/products/tablet-info-genesis.png';
import appOndemandFood from '../assets/products/app-ondemand-food.png';
import appQrQuickpayTall from '../assets/products/app-qr-quickpay-tall.png';
import appReservations from '../assets/products/app-reservations.png';

const CommonAreasPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page commonAreasPage">
      <Header />
      <div className="page-header">Residential Building</div>

      <div className="text-wrapper">
        <div className="top">
          <div className="topic-header">Common Areas</div>
          <Separator />
        </div>
        <div className="std-text">
          {"Provide residents with the ability to pick up their food and beverage orders at various outlets on property or get them delivered directly to their units.\n\nIf they choose to dine at one of the restaurants, they can pay via a QR code on the check or charge it directly to their account.\n\nAllow residents to see availability across all outlets and leverage multiple seat layouts for specified dates."}
        </div>
      </div>

      <FeaturedSolutions>
        <FeaturedItem
          label="InfoGenesis"
          imgSrc={tabletInfoGenesis}
          onClick={() => navigate('/solutions/info-genesis')}
        />
        <FeaturedItem
          label="IG OnDemand"
          imgSrc={appOndemandFood}
          onClick={() => navigate('/solutions/ig-on-demand')}
        />
        <FeaturedItem
          label="IG Quick Pay"
          imgSrc={appQrQuickpayTall}
          onClick={() => navigate('/solutions/ig-quick-pay')}
        />
        <FeaturedItem
          label="Reserve"
          imgSrc={appReservations}
          onClick={() => navigate('/solutions/reserve')}
        />
      </FeaturedSolutions>
    </div>
  );
};

export default CommonAreasPage;
